<template>
<div class="border">
<div id="barcode" class="barcodeStyle">
     <ejs-barcodegenerator
          id="barcode"
          ref="barcodeControl"
          :width="width"
          :height="height"
          :type="type"
          :value="getNumerPz()"
          :mode="mode"
        ></ejs-barcodegenerator>
 </div>
<div class="borderin3">Towar: <strong>{{ getTowar() }}</strong></div>
<div class="borderin1">Dostawca: <strong>{{ getDostawca() }}</strong></div>
<div class="borderin2">Data dostawy: <strong>{{ getDataDostawy() }}</strong></div>
</div>
</template>



<script>
import Vue from 'vue';
import { BarcodeGeneratorPlugin } from '@syncfusion/ej2-vue-barcode-generator';
import * as CONFIG from "./config.js";
import axios from "axios";
import Storage from "./Storage";

axios.defaults.withCredentials = false;

Vue.use(BarcodeGeneratorPlugin);

export default {
	name: 'etykieta',
	props: {
	},
	data: ()=>({
	  dselected: [],
	  data: [],
          width: "200px",
          height: "104px",
          mode: "SVG",
          type: "Code128",
	  jwt: "",
	}),
	methods: {
		getTowar() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].nazwaArtykulu;
			} else {
				return "";
			}
		},
		getDostawca() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].nazwaKontrahenta;
			} else {
				return "";
			}
		},
		getDataDostawy() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].dataPW.substring(0, 10);
			} else {
				return "";
			}
		},
		getNumerPz() {
			if (this.dselected.length > 0) {
				return "" + this.dselected[0].numerPW;
			} else {
				return "";
			}
		},
		getData() {
	  	var url = "/agent/GALEK.Magazyn/GetDokumentPW";
                return axios
                        .get(CONFIG.API_URL + url, {
                        headers: {
                                "Content-Type": "application/x-www-form-urlencoded",
                                "Accept": "application/json",
				"Authorization": "Bearer " +  this.jwt,
                        }
                        })
                        .then(response => {
                                return response.data;
                        })
                        .catch(e => {
                                alert("ERROR" + e);
                        });
        	},
		wrocclick() {
                	this.$router.push({ path: "/dokumentypw" });
        	},

	},
	mounted() {
		var params = this.$route.query;
		var id = "";
		if (params["item"]) {
			id = params["item"];
		}
        	var that = this;
		var selected = [];
        	Storage.loadJWT("jwt").then(resp => {
                	//alert(resp.access_token);
                	that.jwt = resp.access_token;
        		this.getData().then(data => {
                		that.data = data;
				if (id !== "") {
					selected = that.data.filter(function(item) {
						if (item.ID_DOK_MAGAZYNOWEGO == id) return true;
						else return false;
					});
					that.dselected.push(selected.pop());
					//alert(JSON.stringify(that.dselected));
					setTimeout(myprint, 1000);
				}
        		});
        	});
	}
}

function myprint() {
	window.print();
}
</script>

<style>
.wroc {
        width: 200px;
        height: 168px;
        text-align: left;
        float: left;
}
.barcodeStyle {
        height: 110px;
        width: 200px;
    }
.border {
        border: 1px solid green;
        width: 200px;
        height: 278px;
}
.borderin1 {
        width: 200px;
        height: 80px;
}
.borderin2 {
        width: 200px;
        height: 20px;
}
.borderin3 {
        width: 200px;
        height: 40px;
}
.borderin4 {
        width: 200px;
        height: 20px;
}
.borderin5 {
        border: 1px solid black;
        width: 200px;
        height: 50px;
        float: right;
        padding: 2% 2% 2% 2%;
        margin: 2% 2% 5% 2%;
        position: relative;
}
.wroc {
        width: 200px;
        height: 50px;
        position:relative;
        text-align: left;
        background-color: #FFFFFF;
        float: left;
        margin-top: 40px;
        margin-left: 400px;
}
#wroc {
        width: 200px;
        height: 50px;
        position:relative;
        background-color: #FFFFFF;
}
.print { 
	margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/EtykietaDrukujPW.vue